<template>
  <div class="notification-preview">
    <h5 class="title is-6">Detalhes da Notificação</h5>
    <div class="content">
      <p><strong>Título:</strong> {{ title || 'Nova Notificação' }}</p>
      <p><strong>Mensagem:</strong> {{ message }}</p>
      <p v-if="openLink && link">
        <strong>Link de Ação: </strong>
        <a :href="link" target="_blank">{{ link }}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    link: String,
    openLink: Boolean,
    recipients: String,
  },
};
</script>
